module.exports = __webpack_public_path__ + "static/6-florist-707fa33c1146acdf1c7bf637ceb43379.jpg";